import { render, staticRenderFns } from "./TopicRow.vue?vue&type=template&id=2ec438a6&"
import script from "@/components/topic-row/TopicRow.ts?vue&type=script&lang=ts&"
export * from "@/components/topic-row/TopicRow.ts?vue&type=script&lang=ts&"
import style0 from "./topic-row.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports